import type { FacilityStatusesFetchedAction } from '@Application/Facilities/FacilityStatuses/Actions/facilityStatusesFetched';
import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type FacilityStatusesStore = {
	facilityStatuses: readonly LabeledValueView[] | null;
};

const initialState: FacilityStatusesStore = {
	facilityStatuses: null,
};

type Actions = FacilityStatusesFetchedAction | UserRevokedAction;

const whenFacilityStatusesFetched = (
	store: FacilityStatusesStore,
	action: FacilityStatusesFetchedAction,
): FacilityStatusesStore => ({
	...store,
	facilityStatuses: action.payload.map((entry) => new LabeledValueView(entry)),
});

// A catalog of labels has no reason to survive a session: the next session refetches it.
const whenUserRevoked = (): FacilityStatusesStore => initialState;

export default registerStore<'facilityStatusesStore', Actions>(
	'facilityStatusesStore',
	createSliceReducer({
		FACILITY_STATUSES_FETCHED: whenFacilityStatusesFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
